import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-satisfaction-option",
  "use": "icon-satisfaction-option-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-satisfaction-option\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29ZM14.0064 11.212C14.5824 10.86 15.0624 10.492 15.4464 10.076H16.7584V21.5H15.0144V12.172C14.3264 12.828 13.4464 13.308 12.3904 13.612V11.884C12.9024 11.756 13.4304 11.532 14.0064 11.212Z\" fill=\"url(#icon-satisfaction-option_paint0_linear_112582_104275)\" />\n<defs>\n<linearGradient id=\"icon-satisfaction-option_paint0_linear_112582_104275\" x1=\"8\" y1=\"2.5\" x2=\"21.5\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#21D9C2\" />\n<stop offset=\"1\" stop-color=\"#0AC4AD\" />\n</linearGradient>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/satisfaction-option.svg
// module id = eljV
// module chunks = 6 7